import React from 'react';
import { Button } from '@/components/ui/button';
import { Construction, RefreshCcw } from 'lucide-react';

const MaintenancePage = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-background p-4 animate-fade-in text-center">
            <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                <Construction className="w-12 h-12 text-primary animate-pulse" />
            </div>

            <h1 className="text-3xl font-bold tracking-tight mb-2">System Under Maintenance</h1>

            <p className="text-muted-foreground max-w-md mb-8">
                We are currently performing scheduled upgrades to improve your experience.
                Please check back soon.
            </p>

            <div className="flex gap-4">
                <Button variant="outline" onClick={() => window.location.reload()}>
                    <RefreshCcw className="mr-2 h-4 w-4" />
                    Check Again
                </Button>
                <Button variant="ghost" onClick={() => window.location.href = '/'}>
                    Go Home
                </Button>
            </div>

            <p className="mt-12 text-xs text-muted-foreground/50">
                Admin? Log in to bypass.
            </p>
        </div>
    );
};

export default MaintenancePage;
